export default function deliveryReducer(state = {
    isEnabled: globals.config.is_cms_enabled,
    isEditModeEnabled: globals.config.is_cms_edit_mode_enabled,
}, { type }) {
    switch (type) {
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/cms/index.js